import { render, staticRenderFns } from "./TaxiChecklists.vue?vue&type=template&id=0fdd4dc4&"
import script from "./TaxiChecklists.vue?vue&type=script&lang=js&"
export * from "./TaxiChecklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports